const catalogKeys = ['q','view','category','group','status','layout'];
export function catalogReturn(value, category) {
  const fallback = category === 'economy' ? '/economy' : '/realestate';
  if (typeof value !== 'string' || value.length > 4000 || !/^\/(realestate|economy)(\?|$)/.test(value)) return fallback;
  const url = new URL(value, 'https://catalog.local');
  if (!['/realestate','/economy'].includes(url.pathname)) return fallback;
  const params = new URLSearchParams();
  catalogKeys.forEach(key => { if (url.searchParams.has(key)) params.set(key, url.searchParams.get(key)); });
  return url.pathname + (params.toString() ? '?' + params.toString() : '');
}
export function chartMatches(items, query, favoritesOnly, favorites) {
  const words = String(query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  return items.filter(item => (!favoritesOnly || favorites.includes(item.url)) && words.every(word => item.search.includes(word)));
}
export function chartState({ loggedIn, authority, item, loadState }) {
  if (item && item.unavailable) return 'unavailable';
  if (!loggedIn) return 'login';
  if (item && authority < item.authorityLevel) return 'permission';
  return loadState;
}
export function shareChartUrl(category, tableauId) {
  return `https://expert.richgo.ai/${category === 'economy' ? 'economy' : 'realestate'}/${encodeURIComponent(tableauId)}`;
}
